/* AURA stockist locator - no paid APIs, no view caps. MapLibre + OpenFreeMap. */
(function () {
  'use strict';

  var CACHE_KEY = 'aura-stockists-v2';
  var CACHE_TTL = 10 * 60 * 1000; /* 10 min, so sheet edits show up quickly */

  function parseCSV(text) {
    var rows = [], row = [], field = '', inQ = false, i = 0, c, n;
    text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
    for (; i < text.length; i++) {
      c = text[i]; n = text[i + 1];
      if (inQ) {
        if (c === '"' && n === '"') { field += '"'; i++; }
        else if (c === '"') { inQ = false; }
        else { field += c; }
      } else if (c === '"') { inQ = true; }
      else if (c === ',') { row.push(field); field = ''; }
      else if (c === '\n') { row.push(field); rows.push(row); row = []; field = ''; }
      else { field += c; }
    }
    if (field.length || row.length) { row.push(field); rows.push(row); }
    return rows.filter(function (r) { return r.some(function (v) { return String(v).trim() !== ''; }); });
  }

  function toObjects(rows) {
    if (!rows.length) return [];
    var head = rows[0].map(function (h) { return String(h).trim().toLowerCase(); });
    function idx() {
      for (var a = 0; a < arguments.length; a++) {
        var j = head.indexOf(arguments[a]);
        if (j !== -1) return j;
      }
      return -1;
    }
    var iName = idx('store name', 'name', 'store'),
        iAddr = idx('address'), iRegion = idx('region', 'county'),
        iPhone = idx('mobile', 'phone', 'telephone'),
        iUrl = idx('url', 'website'),
        iHours = idx('business hours', 'hours'), iType = idx('type', 'category'),
        iCoord = idx('coordinates', 'coords'),
        iLat = idx('latitude', 'lat'), iLng = idx('longitude', 'lng', 'long');

    var out = [], skipped = 0;
    for (var r = 1; r < rows.length; r++) {
      var row = rows[r];
      var get = function (j) { return j === -1 ? '' : String(row[j] == null ? '' : row[j]).trim(); };
      var lat = NaN, lng = NaN;
      if (iCoord !== -1 && get(iCoord)) {
        var p = get(iCoord).split(',');
        lat = parseFloat(p[0]); lng = parseFloat(p[1]);
      } else {
        lat = parseFloat(get(iLat)); lng = parseFloat(get(iLng));
      }
      var name = get(iName);
      if (!name) { skipped++; continue; }
      if (!isFinite(lat) || !isFinite(lng) || lat < -90 || lat > 90 || lng < -180 || lng > 180) { skipped++; continue; }
      out.push({
        name: name, address: get(iAddr), region: get(iRegion),
        phone: get(iPhone), url: get(iUrl),
        hours: get(iHours), type: get(iType), lat: lat, lng: lng
      });
    }
    out.skipped = skipped;
    return out;
  }

  function haversine(a, b, c, d) {
    var R = 6371, dLat = (c - a) * Math.PI / 180, dLon = (d - b) * Math.PI / 180;
    var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(a * Math.PI / 180) * Math.cos(c * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }

  function init(root) {
    if (root.dataset.auraReady) return;
    root.dataset.auraReady = '1';

    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-aura-config]').textContent); } catch (e) { cfg = {}; }

    var elList = root.querySelector('[data-aura-list]'),
        elSearch = root.querySelector('[data-aura-search]'),
        elRegion = root.querySelector('[data-aura-region]'),
        elNear = root.querySelector('[data-aura-near]'),
        elCount = root.querySelector('[data-aura-count]'),
        elStatus = root.querySelector('[data-aura-status]'),
        elMap = root.querySelector('[data-aura-map]');

    var all = [], view = [], map = null, markers = [], here = null;

    function status(msg, isErr) {
      if (!elStatus) return;
      elStatus.textContent = msg || '';
      elStatus.style.display = msg ? 'block' : 'none';
      elStatus.className = 'aura-loc__status' + (isErr ? ' is-error' : '');
    }

    function fmtDist(km) {
      return km < 1 ? Math.round(km * 1000) + ' m' : km.toFixed(km < 10 ? 1 : 0) + ' km';
    }

    function apply() {
      var q = (elSearch && elSearch.value || '').trim().toLowerCase();
      var reg = elRegion && elRegion.value || '';
      view = all.filter(function (s) {
        if (reg && s.region !== reg) return false;
        if (!q) return true;
        return (s.name + ' ' + s.address + ' ' + s.region + ' ' + s.type).toLowerCase().indexOf(q) !== -1;
      });
      if (here) {
        view.forEach(function (s) { s._d = haversine(here.lat, here.lng, s.lat, s.lng); });
        view.sort(function (x, y) { return x._d - y._d; });
      } else {
        view.forEach(function (s) { s._d = null; });
        view.sort(function (x, y) { return x.name.localeCompare(y.name); });
      }
      render();
    }

    function render() {
      if (elCount) {
        elCount.textContent = view.length + (view.length === 1 ? ' stockist' : ' stockists') +
          (here ? ' · nearest first' : '');
      }
      if (!view.length) {
        elList.innerHTML = '<li class="aura-loc__empty">No stockists match that search. Try a town or county.</li>';
      } else {
        elList.innerHTML = view.map(function (s, i) {
          return '<li class="aura-loc__item" data-i="' + i + '" tabindex="0">' +
            '<div class="aura-loc__row"><span class="aura-loc__name">' + esc(s.name) + '</span>' +
            (s._d != null ? '<span class="aura-loc__dist">' + fmtDist(s._d) + '</span>' : '') + '</div>' +
            (s.address ? '<div class="aura-loc__addr">' + esc(s.address) + '</div>' : '') +
            (s.hours ? '<div class="aura-loc__hours">' + esc(s.hours) + '</div>' : '') +
            '<div class="aura-loc__links">' +
            '<a target="_blank" rel="noopener" href="https://www.google.com/maps/dir/?api=1&destination=' +
            s.lat + ',' + s.lng + '">Directions</a>' +
            (s.phone ? '<a href="tel:' + esc(s.phone.replace(/\s/g, '')) + '">Call</a>' : '') +
            (s.url ? '<a target="_blank" rel="noopener" href="' + esc(s.url) + '">Website</a>' : '') +
            '</div></li>';
        }).join('');
      }
      drawMarkers();
    }

    function drawMarkers() {
      if (!map || !window.maplibregl) return;
      markers.forEach(function (m) { m.remove(); });
      markers = [];
      view.forEach(function (s, i) {
        var el = document.createElement('button');
        el.type = 'button';
        el.className = 'aura-loc__pin';
        el.setAttribute('aria-label', s.name);
        el.addEventListener('click', function () { focus(i, true); });
        markers.push(new window.maplibregl.Marker({ element: el }).setLngLat([s.lng, s.lat]).addTo(map));
      });
      fit(view);
    }

    function fit(pts) {
      if (!map || !pts.length || !window.maplibregl) return;
      if (pts.length === 1) { map.easeTo({ center: [pts[0].lng, pts[0].lat], zoom: 13 }); return; }
      var b = new window.maplibregl.LngLatBounds();
      pts.forEach(function (s) { b.extend([s.lng, s.lat]); });
      map.fitBounds(b, { padding: 48, maxZoom: 13, duration: 500 });
    }

    function focus(i, fromPin) {
      var s = view[i];
      if (!s) return;
      Array.prototype.forEach.call(elList.children, function (li, j) {
        li.classList.toggle('is-active', j === i);
      });
      var li = elList.children[i];
      if (li) li.scrollIntoView({ block: fromPin ? 'center' : 'nearest', behavior: 'smooth' });
      if (map) {
        map.easeTo({ center: [s.lng, s.lat], zoom: Math.max(map.getZoom(), 13) });
        new window.maplibregl.Popup({ offset: 18 })
          .setLngLat([s.lng, s.lat])
          .setHTML('<strong>' + esc(s.name) + '</strong>' + (s.address ? '<br>' + esc(s.address) : ''))
          .addTo(map);
      }
    }

    elList.addEventListener('click', function (e) {
      var li = e.target.closest('.aura-loc__item');
      if (li && !e.target.closest('a')) focus(parseInt(li.dataset.i, 10), false);
    });

    if (elSearch) {
      var t;
      elSearch.addEventListener('input', function () { clearTimeout(t); t = setTimeout(apply, 180); });
    }
    if (elRegion) elRegion.addEventListener('change', apply);

    if (elNear) {
      elNear.addEventListener('click', function () {
        if (!navigator.geolocation) { status('Your browser does not support location sharing.', true); return; }
        var old = elNear.textContent;
        elNear.disabled = true; elNear.textContent = 'Locating…';
        navigator.geolocation.getCurrentPosition(function (pos) {
          here = { lat: pos.coords.latitude, lng: pos.coords.longitude };
          elNear.disabled = false; elNear.textContent = old;
          status(''); apply();
        }, function () {
          elNear.disabled = false; elNear.textContent = old;
          status('Could not get your location. Search by town or county instead.', true);
        }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 });
      });
    }

    function buildMap() {
      if (!window.maplibregl || !elMap) return;
      map = new window.maplibregl.Map({
        container: elMap,
        style: cfg.style || 'https://tiles.openfreemap.org/styles/liberty',
        center: [cfg.lng == null ? -7.9 : cfg.lng, cfg.lat == null ? 53.4 : cfg.lat],
        zoom: cfg.zoom == null ? 5.9 : cfg.zoom
      });
      map.addControl(new window.maplibregl.NavigationControl({ showCompass: false }), 'top-right');
      map.on('load', drawMarkers);
    }

    function boot(csv) {
      all = toObjects(parseCSV(csv));
      if (!all.length) { status('No stockists could be read from the source sheet.', true); return; }
      if (elRegion) {
        var regions = Array.from(new Set(all.map(function (s) { return s.region; }).filter(Boolean))).sort();
        elRegion.insertAdjacentHTML('beforeend', regions.map(function (r) {
          return '<option value="' + esc(r) + '">' + esc(r) + '</option>';
        }).join(''));
        if (regions.length < 2) elRegion.style.display = 'none';
      }
      status(''); apply(); buildMap();
    }

    status('Loading stockists…');

    var cached = null;
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (raw) {
        var o = JSON.parse(raw);
        if (o && o.t && typeof o.d === 'string' && (Date.now() - o.t) < CACHE_TTL) cached = o.d;
      }
    } catch (e) { cached = null; }
    if (cached) { boot(cached); return; }

    if (!cfg.csv) { status('No stockist source configured yet.', true); return; }

    fetch(cfg.csv, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (txt) {
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: txt })); } catch (e) { /* quota */ }
        boot(txt);
      })
      .catch(function () {
        status('We could not load the stockist list just now. Please refresh the page, or get in touch and we will point you to your nearest pharmacy.', true);
      });
  }

  function scan() { document.querySelectorAll('[data-aura-locator]').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', scan); }
  else { scan(); }
  document.addEventListener('shopify:section:load', scan);
})();
